import { STM } from '../context/types';

export const de_deStatements : STM[] = [ 
  {
    "id":1,
    "valueKey": "samen1",
    "title":"ist Zusammenarbeit wichtig",
    "title_360_leadership": "stimuliert das Teamwork",
    "title_360_workenv": "arbeiten wir oft zusammen",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "valueKey": "samen2",
    "title":"geht Teamnutz vor Eigennutz",
    "title_360_leadership": "bevorzugt den Erfolg des Teams vor seinem eigenen",
    "title_360_workenv": "gehen die Interessen des Teams vor den persönlichen Interessen",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "valueKey": "samen3",
    "title":"gibt man sein Bestes für das Team",
    "title_360_leadership": "engagiert sich für sein Team",
    "title_360_workenv": "tut man sein Bestes für das Team",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "valueKey": "conf1",
    "title":"wird eine persönliche Meinung nicht geteilt, wenn sie zu Konflikten führen könnte",
    "title_360_leadership": "äußert keine Meinung, wenn dies zu Konflikten führen könnte",
    "title_360_workenv": "teilt man keine persönliche Meinung mit, wenn dies zu Konflikten führen könnte",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "valueKey": "conf2",
    "title":"werden alle Anstrengungen unternommen, um den Frieden zu wahren",
    "title_360_leadership": "tut alles, um Streitigkeiten zu vermeiden",
    "title_360_workenv": "wird alles getan, um Frieden zu wahren",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "valueKey": "conf3",
    "title":"werden bestehende Handlungsweisen genau befolgt",
    "title_360_leadership": "sorgt dafür, dass Regeln und Normen respektiert werden",
    "title_360_workenv": "werden die bestehenden Regeln und Standards strikt eingehalten",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "valueKey": "erken1",
    "title":"werden Menschen von Mitarbeitern und Managern respektiert",
    "title_360_leadership": "garantiert eine Umgebung, in der sich alle gegenseitig respektieren",
    "title_360_workenv": "werden die Mitarbeiter von Kollegen und Vorgesetzten respektiert",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "valueKey": "erken2",
    "title":"erhält harte Arbeit Anerkennung",
    "title_360_leadership": "gibt Anerkennung für das, was wir tun",
    "title_360_workenv": "wird für harte Arbeit Anerkennung gegeben",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "valueKey": "erken3",
    "title":"wird Einsatz geschätzt und gewürdigt",
    "title_360_leadership": "schätzt die geleistete Anstrengung",
    "title_360_workenv": "wird Engagement geschätzt und gewürdigt",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "valueKey": "zorg1",
    "title":"will man es anderen immer recht machen",
    "title_360_leadership": "ist freundlich und respektvoll",
    "title_360_workenv": "tut man immer das Richtige für andere",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "valueKey": "zorg2",
    "title":"trägt man zum Allgemeinwohl bei",
    "title_360_leadership": "fördert eine Atmosphäre, in der sich jeder wohlfühlt",
    "title_360_workenv": "tritt man anderen zum Wohl bei",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "valueKey": "zorg3",
    "title":"hilft man sich gegenseitig",
    "title_360_leadership": "fördert ein Klima der gegenseitigen Unterstützung",
    "title_360_workenv": "helfen sich die Menschen",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "valueKey": "gelijk1",
    "title":"werden alle gleich behandelt",
    "title_360_leadership": "behandelt jeden fair und gleich",
    "title_360_workenv": "wird jeder gleich behandelt",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "valueKey": "gelijk2",
    "title":"spielen Alter, Herkunft oder Geschlecht keine Rolle",
    "title_360_leadership": "macht keine Unterschiede aufgrund von Alter, Herkunft oder Geschlecht",
    "title_360_workenv": "spielt Alter, Herkunft oder Geschlecht keine Rolle",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "valueKey": "gelijk3",
    "title":"wird man nach seinen Handlungen, nicht nach seinem Charakter beurteilt",
    "title_360_leadership": "bewertet uns auf Basis unserer Handlungen",
    "title_360_workenv": "wird man nach seinen Handlungen, nicht nach seinem Charakter beurteilt",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "valueKey": "zelfsturing1",
    "title":"ist es meistens möglich, eigenverantwortlich zu handeln",
    "title_360_leadership": " sorgt dafür, dass jeder größtenteils selbst bestimmt, was er tut",
    "title_360_workenv": "ist es in der Regel möglich, eigenständig zu handeln",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "valueKey": "zelfsturing2",
    "title":"kann man seine Arbeitsmethode selbst festlegen",
    "title_360_leadership": "lässt uns unsere eigene Arbeitsweise bestimmen",
    "title_360_workenv": "kann man seinen eigenen Arbeitsstil bestimmen",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "valueKey": "zelfsturing3",
    "title":"kann man selbst planen, wie man seine Arbeit durchführt",
    "title_360_leadership": "ermöglicht es größtenteils jedem, seinen eigenen Zeitplan zu bestimmen",
    "title_360_workenv": "kann man sich selbst planen, wie man seine Arbeit erledigt",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "valueKey": "macht1",
    "title":"kann ich das Verhalten anderer beeinflussen",
    "title_360_leadership": "beeinflusst meine Arbeit",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "valueKey": "macht2",
    "title":"bin ich derjenige, der über die Dinge entscheidet, die zu tun sind",
    "title_360_leadership": "sagt, was zu tun ist",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "valueKey": "macht3",
    "title":"bestimme ich, was geschieht",
    "title_360_leadership": "bestimmt, was zu tun ist",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "valueKey": "voorspelbaar1",
    "title":"gibt es Struktur und Regelmässigkeit",
    "title_360_leadership": "garantiert Struktur und Regelmäßigkeit",
    "title_360_workenv": "gibt es Struktur und Regelmäßigkeit",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "valueKey": "voorspelbaar2",
    "title":"ereignen sich die Dinge normalerweise so, wie sie geplant waren",
    "title_360_leadership": "sorgt dafür, dass Dinge im Allgemeinen wie geplant ablaufen",
    "title_360_workenv": "geschehen Dinge in der Regel wie geplant",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "valueKey": "voorspelbaar3",
    "title":"können herkömmliche Werte und Denkweisen aufrechterhalten werden",
    "title_360_leadership": "garantiert den Respekt für traditionelle Werte und Gedanken",
    "title_360_workenv": "können traditionelle Werte und Denkmuster aufrechterhalten werden",
    "preferredType": "workenv"
  },
  {
    "id":25,
    "valueKey": "prestatie1",
    "title":"ist es möglich, sein Bestes zu tun",
    "title_360_leadership": "ermutigt uns, unser Bestes zu geben",
    "title_360_workenv": "ist es möglich, sein Bestes zu leisten",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "valueKey": "prestatie2",
    "title":"kann man seine Kapazitäten in vollem Umfang demonstrieren",
    "title_360_leadership": "ermutigt uns, zu zeigen, was wir können",
    "title_360_workenv": "kann man sein volles Potenzial zeigen",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "valueKey": "prestatie3",
    "title":"kann man in seiner Arbeit Hervorragendes leisten",
    "title_360_leadership": "ermutigt zum Exzellenz in dem, was wir tun",
    "title_360_workenv": "kann man sich in seiner Arbeit auszeichnen",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "valueKey": "zelfontplooi1",
    "title":"kann man ständig neue Sachen lernen",
    "title_360_leadership": "fördert die kontinuierliche Ausbildung",
    "title_360_workenv": "kann man ständig neue Dinge lernen",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "valueKey": "zelfontplooi2",
    "title":"kann man sein Wissen vertiefen",
    "title_360_leadership": "ermutigt uns, unsere Fähigkeiten zu vertiefen",
    "title_360_workenv": "kann man sein Wissen vertiefen",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "valueKey": "zelfontplooi3",
    "title":"kann man seine persönliche Entwicklung kontinuierlich erweitern",
    "title_360_leadership": "hilft anderen, sich zu entwickeln",
    "title_360_workenv": "kann man ständig sein persönliches Wachstum erweitern",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "valueKey": "duurzaam1",
    "title":"wird gute Qualitätsarbeit geliefert",
    "title_360_leadership": "sorgt dafür, dass das Team qualitativ hochwertige Arbeit leistet",
    "title_360_workenv": "wird gute Qualität erbracht",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "valueKey": "duurzaam2",
    "title":"werden Kunden und/oder andere Personen im Geschäft respektiert",
    "title_360_leadership": "ermutigt das Team aktiv, Kunden und andere Beziehungen zu respektieren",
    "title_360_workenv": "werden Kunden und/oder andere im Unternehmen respektiert",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "valueKey": "duurzaam3",
    "title":"berücksichtigt man Menschen, Sicherheit und Umwelt",
    "title_360_leadership": "sorgt dafür, dass wir auf die individuelle Sicherheit und den Umweltschutz achten",
    "title_360_workenv": "hat man Rücksicht auf Menschen, Sicherheit und Umwelt",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "valueKey": "integriteit1",
    "title":"übernimmt man die Verantwortung für seine Handlungen",
    "title_360_leadership": "sorgt dafür, dass wir die Verantwortung für unsere Handlungen übernehmen",
    "title_360_workenv": "wird Verantwortung für Handlungen übernommen",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "valueKey": "integriteit2",
    "title":"sind Menschen ehrlich",
    "title_360_leadership": "ist ehrlich",
    "title_360_workenv": "sind die Menschen ehrlich",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "valueKey": "integriteit3",
    "title":"wird Vertraulichkeit respektiert",
    "title_360_leadership": "behandelt persönliche und vertrauliche Informationen sorgfältig",
    "title_360_workenv": "wird Vertraulichkeit respektiert",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "valueKey": "innovatie1",
    "title":"können neue Dinge ausprobiert werden",
    "title_360_leadership": "ermutigt uns, neue Arbeitsweisen auszuprobieren",
    "title_360_workenv": "können neue Dinge versucht werden",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "valueKey": "innovatie2",
    "title":"macht man viele Erfahrungen",
    "title_360_leadership": "ermutigt zur Erlangung neuer Erfahrungen",
    "title_360_workenv": "hat man viele neue Erfahrungen",
    "preferredType": "workenv"
  },
  {
    "id":39,
    "valueKey": "innovatie3",
    "title":"können Herausforderungen angestrebt werden",
    "title_360_leadership": " stimuliert uns, neue Herausforderungen zu suchen",
    "title_360_workenv": "können Herausforderungen gesucht werden",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "valueKey": "daadkracht1",
    "title":"ergreift man Initiativen, um Aufgaben anzupacken",
    "title_360_leadership": "ermutigt zur Selbstinitiative bei Aufgaben",
    "title_360_workenv": "nimmt man die Initiative, um Aufgaben anzunehmen",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "valueKey": "daadkracht2",
    "title":"wird der Tatsache eine hohe Priorität beigemessen, alles zu tun, um Ergebnisse zu erreichen",
    "title_360_leadership": "sorgt dafür, dass die Ergebnisse erreicht werden",
    "title_360_workenv": "wird alles getan, um Ergebnisse zu erzielen, und das wird hohe Priorität eingeräumt",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "valueKey": "daadkracht3",
    "title":"werden alle möglichen Anstrengungen unternommen, um die gestellten Ziele zu erreichen",
    "title_360_leadership": "setzt alles daran, die festgelegten Ziele zu erreichen",
    "title_360_workenv": "wird alles getan, um die festgelegten Ziele zu erreichen",
    "preferredType": "leadership"
  }
]

export const extra360De_DeStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'trifft Entscheidunge',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'respektiert und schätzt die Unterschiede zwischen den Teammitgliedern',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'gibt konstruktives Feedback',
      preferredType: 'leadership',
    },
]

